import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=0e0923a2&scoped=true"
import script from "./BaseFormInput.vue?vue&type=script&lang=js"
export * from "./BaseFormInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=0e0923a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0923a2",
  null
  
)

export default component.exports